export default __webpack_public_path__ + "static/media/meslay12.e3072b87.jpg";